/**
 * PURPOSE: Resolver el N° impreso de la tabla de Programación (FTR-0035).
 * RESPONSIBILITIES: Fase de grupos: repartir en orden de render los nro_match de los partidos con
 *   ambos equipos (los descansos no consumen número), igual que antes. Fase final (idtypephase 2):
 *   el nro_match propio de la llave, aunque sus equipos estén "Por definir".
 * COLLABORATORS: ProgramacionArea.jsx.
 * ROUTE: winscore/src/utils/programacionMatchNumber.js
 */

const FINAL_PHASE_ID = 2;

export const isFinalPhaseMatch = (match) => Number(match?.idtypephase) === FINAL_PHASE_ID;

const hasBothParticipants = (match) => Boolean(match?.Participant1 && match?.Participant2);

// Devuelve el resolvedor de una tabla: se llama una vez por fila, en el mismo orden en que se
// renderizan. "" significa sin número (la tabla muestra "-").
export const createMatchNumberResolver = (visibleMatches = []) => {
  // El pool solo se arma con filas de grupos: la fase final nunca lo consume.
  const numerosDisponibles = visibleMatches
    .filter((m) => !isFinalPhaseMatch(m) && hasBothParticipants(m))
    .map((m) => m.nro_match)
    .filter((n) => n != null)
    .sort((a, b) => Number(a) - Number(b));

  let idxNumeroDisponible = 0;

  return (match) => {
    if (isFinalPhaseMatch(match)) return match.nro_match ?? "";

    return hasBothParticipants(match) ? numerosDisponibles[idxNumeroDisponible++] ?? "" : "";
  };
};
